export const async_homedepot_reviews = {
  input: "320326855",
  result: `{
  "success": true,
  "payload": {
    "reviews": [
      {
        "position": 1,
        "id": "406342610",
        "item_id": "320326855",
        "title": "As always great products",
        "body": "Pick up my tools the day before installing my son front door.",
        "rating": 5,
        "positive_feedback": 0,
        "negative_feedback": 0,
        "date": "2026-09-28T11:07:08.000+00:00",
        "source": { "is_external_source": true, "external_source": true, "author_name": "Papatrunk", "verified_purchase": false }
      },
      {
        "position": 2,
        "id": "306961819",
        "item_id": "320326855",
        "title": "Unapologetically RED.",
        "body": "The workhorse. Legendary, consistent, unapologetically RED. It has the anti kickback feature finally and can rip holes like no other.",
        "rating": 5,
        "is_recommended": true,
        "positive_feedback": 0,
        "negative_feedback": 0,
        "date": "2026-09-28T00:44:58.000+00:00",
        "source": { "is_external_source": true, "external_source": false, "author_name": "ksarcia", "author_location": "Peabody MA", "verified_purchase": false }
      }
    ],
    "summary": {
      "rating": 4.7,
      "ratings_total": 1698,
      "recommended_count": 483,
      "not_recommended_count": 36,
      "rating_breakdown": { "five_star": 1450, "four_star": 126, "three_star": 30, "two_star": 16, "one_star": 76 }
    },
    "product": { "item_id": "320326855" },
    "pagination": { "current_page": 1, "next_page": 2, "total_pages": 57, "total_reviews": 1698 }
  }
}`
};
